import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { Box, Button, CircularProgress, Stack, Tooltip, Typography } from "@mui/material";
import { MainBtnContent } from "./MainButtonContent";
import { UpdatedCost } from "./UpdatedCost";
import { useMyMealsCartButton } from "./useMyMealsCartButton";
export const CartButton = ({ selectedOrder, selectedFutureOrder, quickSaveToolTipText, toggleDrawer, cartIcon, isUpdatingPrice, selectedMealQuantity, totalMealQuantity, subtotal, checkSubscriptionMealsPrehook, saveAndUpdateCart, saveAndUpdateText, saveAndUpdateFutureOrder, showQuickSaveButton, }) => {
    const { btnOnClick, btnText, customCartIconUrl, isCustomCartIconWhite, isMobile, isVisible, loading, shouldFade, showUpdatedCost, } = useMyMealsCartButton({
        saveAndUpdateCart,
        saveAndUpdateFutureOrder,
        saveAndUpdateText,
        selectedFutureOrder,
        selectedOrder,
        showQuickSaveButton,
        subtotal,
    });
    return (_jsxs(Stack, Object.assign({ spacing: 0.5, sx: (theme) => ({
            position: "fixed",
            right: isMobile ? 12 : 0,
            bottom: isMobile ? 12 : null,
            left: isMobile ? 12 : null,
            zIndex: 1100,
            padding: 0.75,
            backgroundColor: isMobile && shouldFade ? theme.palette.common.white : "initial",
            borderRadius: isMobile && shouldFade ? "5px" : null,
            boxShadow: isMobile && shouldFade ? 16 : null,
            transition: "box-shadow 0.5s ease-in-out, border-radius 0.5s ease-in-out, background-color 0.5s ease-in-out",
        }) }, { children: [isMobile && (_jsx(Box, Object.assign({ sx: {
                    opacity: shouldFade ? 1 : 0,
                    transform: shouldFade ? "translateY(0)" : "translateY(4px)",
                    transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                } }, { children: _jsx(Typography, Object.assign({ variant: "body2" }, { children: quickSaveToolTipText })) }))), _jsxs(Stack, Object.assign({ sx: {
                    gap: 0.5,
                    flexDirection: isMobile ? "row-reverse" : "column",
                } }, { children: [_jsx(LoadingButton, Object.assign({ fullWidth: true, loading: isUpdatingPrice || loading, loadingIndicator: _jsx(CircularProgress, { color: "primary", size: isMobile ? 16 : 40 }), onClick: toggleDrawer(true), variant: "outlined", sx: (theme) => ({
                            backgroundColor: theme.palette.common.white,
                            padding: isMobile ? null : "10px",
                            opacity: isMobile ? null : 1,
                            transition: isMobile ? null : "opacity 0.4s",
                            width: isMobile ? "120px" : "120px",
                            height: isMobile ? "80px" : "120px",
                            flexShrink: 0,
                            boxShadow: isMobile ? 10 : 1,
                        }) }, { children: !isUpdatingPrice && !loading && (_jsxs(Stack, Object.assign({ sx: {
                                alignItems: "center",
                                justifyContent: "center",
                                flexWrap: "nowrap",
                                width: "100%",
                                height: "100%",
                            } }, { children: [!isMobile && (_jsx(Box, Object.assign({ sx: (theme) => ({
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        height: theme.spacing(3.5),
                                        width: theme.spacing(3.5),
                                    }) }, { children: _jsx(Tooltip, Object.assign({ title: quickSaveToolTipText, leaveDelay: 200, placement: "top-start", arrow: true }, { children: _jsx(Box, { component: "i", className: "fas fa-info-circle fa-sm" }) })) }))), _jsx(MainBtnContent, Object.assign({}, {
                                    cartIcon,
                                    isUpdatingPrice,
                                    selectedMealQuantity,
                                    totalMealQuantity,
                                    customCartIconUrl,
                                    isCustomCartIconWhite,
                                    loading,
                                })), _jsx(UpdatedCost, { showUpdatedCost: showUpdatedCost, subtotal: subtotal })] }))) })), isVisible && (_jsx(Button, Object.assign({ color: "secondary", disabled: isUpdatingPrice || loading, fullWidth: true, onClick: checkSubscriptionMealsPrehook.bind(this, btnOnClick), size: "small", variant: "contained", sx: {
                            opacity: shouldFade ? 1 : 0,
                            transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                            flexGrow: isMobile ? 1 : 0,
                            fontSize: isMobile ? 16 : null,
                            boxShadow: isMobile ? 10 : null,
                        } }, { children: btnText })))] }))] })));
};
